import styled, { css, keyframes } from 'styled-components'

import { Reset, TransitionPrimary } from '@/lib/mixins'

const caretBlink = keyframes`
  0%, 49% { opacity: 1; }
  50%, 100% { opacity: 0; }
`

export const InputWrapper = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  width: 100%;
`

export const InputLabel = styled.span`
  font-size: 1.1rem;
  font-weight: 600;
`

export const InputControlWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const InputCaret = styled.span<{ $left: number }>`
  position: absolute;
  top: 50%;
  left: ${({ $left }) => `${$left}px`};
  transform: translateY(-50%);
  width: 2px;
  height: 1.4em;
  background: currentColor;
  pointer-events: none;
  animation: ${caretBlink} 1s steps(1, end) infinite;
`

export const InputControl = styled.input<{ $hasError?: boolean }>`
  ${Reset('all')}
  appearance: none;
  width: 100%;
  height: 4rem;
  border: 1px solid ${({ theme }) => theme.color.line};
  padding: 0 1.15rem;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.color.global};
  background: ${({ theme }) => theme.color.body};
  ${TransitionPrimary('border-color', 'box-shadow')}

  &::placeholder {
    color: ${({ theme }) => theme.color.muted};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button,
  &::-webkit-search-cancel-button {
    appearance: none;
    margin: 0;
  }

  &:focus {
    border-color: currentColor;
    box-shadow: none;
    outline: 0;
  }

  ${({ $hasError }) =>
    $hasError &&
    css`
      border-color: ${({ theme }) => theme.color.red};
    `};
`

export const InputError = styled.span`
  min-height: 1rem;
  color: ${({ theme }) => theme.color.red};
  font-size: 0.85rem;
  line-height: 1.2;
`
